import { render } from "./AddFinAccount.vue?vue&type=template&id=f3ecdf34"
import script from "./AddFinAccount.vue?vue&type=script&lang=js"
export * from "./AddFinAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__